function toDataUrl(svg) {
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
}

export const DEFAULT_VIDEO_PLACEHOLDER = toDataUrl(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 180">
    <defs>
      <linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#0f172a" />
        <stop offset="100%" stop-color="#1d4ed8" />
      </linearGradient>
    </defs>
    <rect width="320" height="180" rx="18" fill="url(#bg)" />
    <circle cx="160" cy="90" r="28" fill="rgba(255,255,255,0.18)" />
    <polygon points="153,76 153,104 176,90" fill="#ffffff" />
    <text x="160" y="146" text-anchor="middle" font-size="18" font-family="Arial, sans-serif" fill="#e2e8f0">Video</text>
  </svg>
`)

export const DEFAULT_AVATAR_PLACEHOLDER = toDataUrl(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96">
    <defs>
      <linearGradient id="avatarBg" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#cbd5f5" />
        <stop offset="100%" stop-color="#94a3b8" />
      </linearGradient>
    </defs>
    <rect width="96" height="96" rx="48" fill="url(#avatarBg)" />
    <circle cx="48" cy="36" r="18" fill="#f8fafc" />
    <path d="M24 78c4-14 18-22 24-22s20 8 24 22" fill="#f8fafc" />
  </svg>
`)
